<template>
    <div class="h-full" v-if="hackReset">
        <div :class="config.isDetailDisplay ? 'small-list' : 'scroll-auto'">
            <Control ref="control" :config="config" @onChangeEditDataSource="onChangeEditDataSource"></Control>
        </div>
        <div v-show="config.isDetailDisplay&&config.isNormal" class="detail">
            <EditControl ref="normalOrder" :dataSource="editDataSource" :config="config"></EditControl>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                hackReset: true,
                config: {
                    isDetailDisplay: false,
                    isNormal: false,
                    isReturn: false,
                    isAdd: false,
                    isCanEdit: false,
                    dataSourceKey:0
                },
                editDataSource: {
                    OrderExtend: {},
                    ReceiverSource: {},
                    SenderSource: {},
                    OrderProductPage: {},
                    OrderReceiptPage: {}
                },
                editReturnDataSource: {
                    ReceiverSource: {},
                    SenderSource: {},
                    OriginOrderInfo: {},
                },
            }
        },
        methods: {
            onChangeEditDataSource: function (dataSourceKey) {
                this.config.dataSourceKey = dataSourceKey;
            }
        },
        components: {
            "EditControl": resolve => { require(['./components/edit.vue'], resolve) },
            "Control": resolve => { require(['./components/list.vue'], resolve) },
        }
    }
</script>